import React from "react";
import { aboutImages } from "../../utils/constants";
import headingImg2 from "../../assets/headingImg2.svg";
import CustomHeading from "../custom/CustomHeading";
import CustomContent from "../custom/CustomContent";

const Vision = () => {
  return (
    <div
      id="vision"
      className="flex font-Lato text-justify lg:flex-row flex-col justify-between items-center lg:mt-0 mt-[3rem] mx-[3%] 2xl:mx-[8%] py-0 sm:py-[20px] lg:gap-[6rem]"
    >
      <div className="lg:w-[50%] flex  flex-col justify-center lg:min-h-[32rem]">
        <div className="relative  gap-5">
          <CustomHeading
            text={"Our "}
            customImg={headingImg2}
            heartHeight="60px"
            heartWidth="60px"
            spanText={"Vision"}
            spanTextColor="#d31c4f"
            smTextSize="32px"
          />
          <CustomContent
            marginTop="0px"
            textAlign="justify"
            fontWeight={600}
            textColor="#636363"
            text={`'To instill life-long values that nurture humanity, create global
          citizens, and give shape to a better world.'`}
          />
          <CustomContent
            marginTop="10px"
            textAlign="justify"
            fontWeight={500}
            textColor="#636363"
            textSize="20px"
            leading="29px"
            text={
              "In the early years of education, love is the foundation upon which learning blossoms. When children feel safe, cherished, and valued, they develop the confidence to explore, question, and grow. Love nurtures curiosity, fosters emotional security, shaping young minds into compassionate individuals. A warm and caring environment allows children to embrace diversity, form meaningful connections, and understand the beauty of kindness. It is through love that the seeds of lifelong learning, empathy, and humanity are sown, ensuring that every child flourishes with a heart full of dreams and a spirit ready to embrace the world."
            }
          />
        </div>
      </div>
      <div className="mx-auto lg:mx-0 md:max-w-[730px] w-[100%] lg:w-[50%]">
        <img
          src={
            window.innerWidth < 750
              ? window.innerWidth < 450
                ? aboutImages.mobileVisionImg
                : aboutImages.tabMissionImg
              : aboutImages.visionImg
          }
          style={{ marginTop: "30px" }}
          alt=""
          className="rounded-lg h-[250px] mx-auto sm:h-[400px] 2xl:min-w-[620px] sm:w-full w-[380px] lg:h-[380px]"
        />
      </div>
    </div>
  );
};

export default Vision;
